import { render, staticRenderFns } from "./RefundOrEmdTemplate.vue?vue&type=template&id=19d85f3a&scoped=true&"
import script from "./RefundOrEmdTemplate.vue?vue&type=script&lang=js&"
export * from "./RefundOrEmdTemplate.vue?vue&type=script&lang=js&"
import style0 from "./RefundOrEmdTemplate.vue?vue&type=style&index=0&id=19d85f3a&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19d85f3a",
  null
  
)

export default component.exports